import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit {

  totalRows = 0;
  currentPage = 0;
  totalPages = 0;
  arrayPagination = [];
  $data = [];
  $registersPerPage = 10;
  @Input() set registersPerPage( items: number ) {
    this.$registersPerPage = +items;
    this.init();
  }

  @Input()
  set data(data: Array<any>) {
    if (data) {
      this.$data = data;
      this.init();
    }
  }

  @Output() changePage = new EventEmitter<Array<any>>();

  constructor() { }

  ngOnInit(): void {
  }

  init(): void {
    this.totalRows = this.$data.length;
    this.currentPage = 0;
    this.totalPages = Math.ceil(this.totalRows / this.$registersPerPage);

    this.arrayPagination = Array.from(Array(this.totalPages).keys());

    this.goToPage(this.currentPage);
  }

  // Metodo requerido para paginación
  goToPage(index: number): void {
    if (this.totalPages === 0) {
      this.changePage.emit([]);
      return;
    }

    if (index >= 0 && index <= this.totalPages - 1) {
      this.currentPage = index;

      const data = this.$data.slice(
        this.currentPage * this.$registersPerPage,
        this.$registersPerPage + (this.currentPage * this.$registersPerPage)
      );

      this.changePage.emit(data);
    }
  }

  // Metodo requerido para paginación
  showPage(index: number): boolean {
    const abs = Math.abs(this.currentPage - index);

    return  index === 0 ||
            index === this.totalPages - 1 ||
            ( index <= 4 && this.currentPage < 4) ||
            (this.totalPages - 1) - index <= 4  && this.currentPage > (this.totalPages - 1) - 4 ||
            ((abs >= 0 && abs <= 1));
  }

  // Metodo requerido para paginación
  showDots(index: number): boolean {
    const abs = Math.abs(this.currentPage - index);
    return  (this.currentPage < 3 &&  abs === 5) ||
            (this.currentPage > (this.totalPages - 1) - 3 &&  abs === 5)  ||
            abs === 2 ;
  }

}
